import React from 'react';
import styled from 'styled-components';
import Hero from 'components/Hero';
import { Content } from 'components/Layout';
import HeroBgImage from 'assets/img/small_molecule_drugs.jpeg';

const SmallMoleculeDrugsOverview = () => {
  const title = 'Small Molecule Drugs';
  const subtitle = `AI and Quantum-Enhanced Platform for Next-Generation Small-Molecule Drug Discovery`;
  const navigateToLogIn = (path) => {
    const url = path; // build absolute URL
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const heroButtons = [
    {
      label: 'Sign In',
      type: 'primary',
      size: 'large',
      onClick: () => navigateToLogIn('http://106.14.212.218'),
    },
  ];

  return (
    <SmallMoleculeDrugs>
      <Hero title={title} subtitle={subtitle} bgImage={HeroBgImage} buttons={heroButtons}/>
      <Content>
        <p>Genion Quantum Tech has developed an integrated LLM-Transformer-driven drug discovery platform to enable accurate generation of de novo small-molecule lead compounds across biomedical targets.</p>
        <p>Genion Quantum Tech has developed a proprietary technology that integrates graph neural network (GNN) architecture with LLMs to enable advanced molecular fragment information extraction and molecular assembly/Design. This powerful technology expands chemical space with enhanced scaffold diversity and improved bioavailability, accelerating the discovery of next-generation therapeutics.</p>
        <p>In addition, we have curated a comprehensive bioactive drug molecule database covering over 50,000 targets, and independently developed an innovative platform for extracting molecule–target reaction pathway information.</p>
      </Content>
    </SmallMoleculeDrugs>
  );
};

const SmallMoleculeDrugs = styled.div`
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export default SmallMoleculeDrugsOverview;